module.exports = __webpack_public_path__ + "img/data-chart.0391e99a.png";